import { Component, Vue } from 'vue-property-decorator';
import TombolaBaseComponent from '@/components/base/base.component';
import userSettingsViewComponents from '@/components/user-settings/_components';
import { UserPreferences } from '@/app-modules/store/modules/user-preferences';
import { UserSettingsUpdatedEventName, IUserSettingsComponent } from '@/components/user-settings/_domain/models';

enum UserSettingsSavingStatus {
  NotSet = 0,
  Saving,
  Saved
}

@Component({
  name: 'UserSettingsComponent',
  components: userSettingsViewComponents
})
export default class UserSettingsComponent extends TombolaBaseComponent {
  private userPreferences: UserPreferences = null;
  private isInternationalSettings: boolean = false;
  private savingStatus: UserSettingsSavingStatus = UserSettingsSavingStatus.NotSet;

  private get isSaving(): boolean {
    return this.savingStatus !== UserSettingsSavingStatus.NotSet;
  }

  private get savingCssClasses(): { [key: string]: boolean } {
    return {
      'fa-spin fa-circle-o-notch': this.savingStatus === UserSettingsSavingStatus.Saving,
      'fa-check': this.savingStatus === UserSettingsSavingStatus.Saved
    };
  }

  protected async created() {
    this.userPreferences = this.$tombolaStore.Get(UserPreferences);
    this.isInternationalSettings = this.userPreferences.country.toLowerCase() === 'uk' ? false : true;
  }

  private saveSettings() {
    this.setSavingStatus(UserSettingsSavingStatus.Saving);
    try {
      this.saveSettingsForEachUserSettingComponent();
      this.saveUserPreferences();
      this.emitUserSettingsUpdatedEvent();
    } finally {
      this.setSavingStatus(UserSettingsSavingStatus.Saved);
    }
  }

  private setSavingStatus(status: UserSettingsSavingStatus): void {
    const timeout = status === UserSettingsSavingStatus.Saving ? 0 : 400;
    setTimeout(() => {
      this.savingStatus = status;
      if (status === UserSettingsSavingStatus.Saved) {
        this.setSavingStatus(UserSettingsSavingStatus.NotSet);
      }
    }, timeout);
  }


  private emitUserSettingsUpdatedEvent(): void {
    this.$eventbus.$emit(UserSettingsUpdatedEventName);
  }

  private saveUserPreferences(): void {
    this.$tombolaStore.Save(this.userPreferences);
  }

  private saveSettingsForEachUserSettingComponent(): void {
    for (const referenceName in this.$refs) {
      if (this.$refs.hasOwnProperty(referenceName)) {
        const component = this.$refs[referenceName];
        this.saveSettingsForUserSettingsComponent(component);
      }
    }
  }

  private saveSettingsForUserSettingsComponent(component: Vue | Element | Vue[] | Element[]): void {
    try {
      (component as IUserSettingsComponent).saveSettings();
    } catch (err) {
      this.logError(err);
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/user-settings/user-settings.component.ts